'use strict';

const toPx = (maybePx) => {
    if (typeof maybePx === 'number')
        return maybePx;
    if (!maybePx.endsWith('px'))
        throw new Error(`not px unit: "${maybePx}"`);
    return parseFloat(maybePx);
};
const makePxToRem = (rootFontSize) => (px) => `${toPx(px) / toPx(rootFontSize)}rem`;
const makePxToEm = (rootFontSize) => (px) => `${toPx(px) / toPx(rootFontSize)}em`;
const makeRemToPx = (rootFontSize) => (rem) => {
    if (!rem.endsWith('rem'))
        throw new Error(`not rem unit: "${rem}"`);
    const remAsNumber = parseFloat(rem);
    const baseFontSize = toPx(rootFontSize);
    return remAsNumber * baseFontSize;
};
const makeEmToPx = (rootFontSize) => (em) => {
    if (em.endsWith('rem') || !em.endsWith('em'))
        throw new Error(`not em unit: "${em}"`);
    const emAsNumber = parseFloat(em);
    const baseFontSize = toPx(rootFontSize);
    return emAsNumber * baseFontSize;
};
const rootElement = globalThis.document?.querySelector(':root');
const rootFontSizeInPx = globalThis.getComputedStyle?.(rootElement).fontSize || '16px';
const remToPx = makeRemToPx(rootFontSizeInPx);
const emToPx = makeEmToPx(rootFontSizeInPx);
const pxToEm = makePxToEm(rootFontSizeInPx);
const pxToRem = makePxToRem(rootFontSizeInPx);

exports.emToPx = emToPx;
exports.makeEmToPx = makeEmToPx;
exports.makePxToEm = makePxToEm;
exports.makePxToRem = makePxToRem;
exports.makeRemToPx = makeRemToPx;
exports.pxToEm = pxToEm;
exports.pxToRem = pxToRem;
exports.remToPx = remToPx;
//# sourceMappingURL=css-units.js.map
